import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

import { StoresContext } from '../../../provider/StoreProvider'

import { Head } from '../../../components/head/Head'
import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { RowBetween } from '../../../components/common'
import { Chip } from '../../../components/chip'
import { Text } from '../../../components/text'
import { Header } from '../../../components/header'
import { List } from '../components/SettingListContainer'

import { Color } from '../../../theme/color'

import { ReactComponent as StateDownIcon } from '../../../assets/ico/common/expand/expand_down.svg'
import { ReactComponent as StateUpIcon } from '../../../assets/ico/common/expand/expand_up.svg'

import FaqData from './FaqData'
import type { Faq } from './FaqData'

type FaqCategory = Faq['category'] | '전체'

const HEAD_INFO = {
  title: '자주 묻는 질문 | 미술품 조각투자 플랫폼, 아티피오',
  ogTitle: '자주 묻는 질문 | 미술품 조각투자 플랫폼, 아티피오',
  ogUrl: window.location.href,
}

export function Faq() {
  const { commonStore } = useContext(StoresContext)

  const [activeId, setActiveId] = useState<number | undefined>()
  const [categories, setCategories] = useState<FaqCategory[]>([])
  const [selectCategory, setSelectCategory] = useState<FaqCategory>('전체')

  useEffect(() => {
    commonStore.setShowTab(false)
  }, [])

  useEffect(() => {
    const temp: FaqCategory[] = ['전체']

    FaqData.list.forEach(({ category }) => {
      if (temp.includes(category)) return
      temp.push(category)
    })

    setCategories(temp)
  }, [FaqData])

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="자주 묻는 질문" />
        <StyledContent>
          <CategoryBox>
            {categories.map((category) => {
              const isActive = selectCategory === category

              const handleCategory = () => setSelectCategory(category)

              return (
                <Chip key={category} $color={isActive ? 'black' : 'white'} onClick={handleCategory}>
                  {category}
                </Chip>
              )
            })}
          </CategoryBox>
          <List>
            {FaqData.list
              .filter(({ category }) => selectCategory === '전체' || category === selectCategory)
              .map(({ id, title, content }) => {
                const isActive: boolean = id === activeId

                const handleActive = () => setActiveId(isActive ? undefined : id)

                return (
                  <Item key={id}>
                    <Title onClick={handleActive}>
                      <Text size={16} weight={500} lineHeight={24} block={true} $wordBreak="keep-all">
                        {title}
                      </Text>
                      {isActive ? <StateUpIcon /> : <StateDownIcon />}
                    </Title>
                    {isActive && (
                      <Description>
                        <Text size={14} lineHeight={22} $wordBreak="keep-all">
                          {content}
                        </Text>
                      </Description>
                    )}
                  </Item>
                )
              })}
          </List>
        </StyledContent>
      </Wrap>
    </>
  )
}

const StyledContent = styled(Content)`
  padding-bottom: env(safe-area-inset-bottom);
`

const CategoryBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0;
  padding: 0 16px;
`

const Item = styled.li`
  list-style: none;
`

const Title = styled(RowBetween)`
  gap: 8px;
  position: relative;
  padding: 16px 16px 16px 24px;
  &::after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    left: 24px;
    width: calc(100% - 24px * 2);
    height: 1px;
    border-bottom: 1px solid ${Color.line};
  }
  > svg {
    flex-shrink: 0;
  }
`

const Description = styled.div`
  padding: 16px 24px;
  background-color: ${Color.gray_1};
`
